<script setup>
import { computed, watch, ref } from 'vue'
import { useNuxtApp, useRoute } from '#app'
import { useRouter } from 'vue-router'
const { $_ } = useNuxtApp()

const router = useRouter()
const route = useRoute()

const clearNext = ref(false)

const clearBreadCrubmsHistory = () => {
  clearNext.value = true
  visitedPaths.value = []
  realNames.value = []
}

defineExpose({
  clearBreadCrubmsHistory,
})

const pathsWithTranslations = [
  { path: 'dashboard', translation: $_('components/navbar.menu_items.dashboard', 'Přehled') },
  {
    path: 'waste-collection-routes',
    translation: $_('components/navbar.menu_items.waste_collection_routes', 'Svozové trasy'),
  },
  {
    path: 'waste-company-resources',
    translation: $_('components/navbar.menu_items.waste_company_resources', 'Zdroje'),
  },
  { path: 'waste-evidence-headers', translation: $_('components/navbar.menu_items.waste_evidence_headers', 'Nádoby') },
  { path: 'waste-customers', translation: $_('components/navbar.menu_items.waste_customers', 'Zákazníci') },
  {
    path: 'waste-company-administration',
    translation: $_('components/navbar.menu_items.waste_company_administration', 'Správa'),
  },
  { path: 'waste-companies', translation: $_('components/navbar.menu_items.waste_companies', 'Technické služby') },
  { path: 'cars', translation: $_('components/navbar.menu_items.waste_company_resources.cars', 'Auta') },
  { path: 'workers', translation: $_('components/navbar.menu_items.waste_company_resources.workers', 'Personál') },
  {
    path: 'external-services',
    translation: $_('components/navbar.menu_items.waste_company_resources.external_services', 'Externí služby'),
  },
  { path: 'export', translation: $_('components/navbar.menu_items.waste_customers.export', 'Export') },
  { path: 'list', translation: $_('components/navbar.menu_items.waste_companies.list', 'Seznam') },
  { path: 'users', translation: $_('components/navbar.menu_items.administration.users', 'Správa uživatelů') },
  { path: 'devices', translation: $_('components/navbar.menu_items.administration.devices', 'Správa zařízení') },
  {
    path: 'external-services',
    translation: $_('components/navbar.menu_items.administration.external_services', 'Externí služby'),
  },
  { path: 'regular', translation: $_('components/navbar.menu_items.waste_collection_routes.regular', 'Trasy') },
  {
    path: 'exceptional',
    translation: $_('components/navbar.menu_items.waste_collection_routes.exceptional', 'Mimořádné svozy'),
  },
  { path: 'calendar', translation: $_('components/navbar.menu_items.waste_collection_routes.calendar', 'Kalendář') },
  {
    path: 'waste-company-selection',
    translation: $_('components/navbar.modal.waste_company_selection', 'Výběr firmy'),
  },
  {
    path: 'select-waste-company',
    translation: $_('components/navbar.modal.buttons.select_waste_company', 'Vybrat firmu'),
  },
  { path: 'user-profile', translation: $_('components/navbar.modal.buttons.user_profile', 'Profil uživatele') },
  { path: 'logout', translation: $_('components/navbar.modal.buttons.logout', 'Odhlásit') },
  { path: 'version', translation: $_('components/navbar.modal.version', 'verze') },
  { path: 'edit', translation: $_('navbar.navigation.edit', 'Upravit') },
  { path: 'create', translation: $_('navbar.navigation.create', 'Vytvořit') },
]

const minusOneExceptionsNames = ['waste-evidence-headers', 'waste-customers', 'waste-companies']
const firstPathExceptionsNames = ['waste-customers', 'administration']
const secondPathExceptionsNames = ['export']
let visitedPaths = ref([])
let realNames = ref([])
let observer

function name(path) {
  if (!path) {
    return ''
  }
  const foundTranslations = pathsWithTranslations.find(p => p.path === path.name)
  if (foundTranslations) {
    return foundTranslations.translation
  }
  if (Number.parseInt(path.name)) {
    const realName = realNames.value.find(rn => rn.name == path.name)
    if (realName) {
      return realName.realName
    }
  }
  return path.name
}

watch(
  () => route.path,
  (newValue, oldValue) => {
    if (clearNext.value) {
      clearNext.value = false
      return
    }
    handleVisitedPaths()
  },
  { deep: true }
)

function handleVisitedPaths() {
  const currentRoute = route.path
  //Dont do anything if /
  if (currentRoute == '/') {
    visitedPaths.value = []
    return
  }
  //Path formatting
  const currentPath = pathToArray(pathNoIndex(currentRoute))
  if (!Array.isArray(currentPath) || currentPath.length === 0) {
    console.error('Invalid currentPath:', currentPath)
    visitedPaths.value = []
    return
  }
  //Path array used for when need to access all routes
  const formattedCurrentPath = currentPath.map((name, index) => {
    const path = '/' + currentPath.slice(0, index + 1).join('/')
    return { name, path }
  })
  //ready to be added to visitedPaths.value
  let path
  if (minusOneExceptionsNames.includes(formattedCurrentPath[0].name)) {
    path = formattedCurrentPath
  }
  if (firstPathExceptionsNames.includes(formattedCurrentPath[0].name)) {
    if (formattedCurrentPath.length > 1 && !secondPathExceptionsNames.includes(formattedCurrentPath[1].name)) {
      path = formattedCurrentPath
    }
  }
  if (!path) {
    path = formattedCurrentPath.slice(1)
  }
  // For setting the title as a name
  const lastElement = path[path.length - 1]

  //if its id it will get h1 and add it for later translation
  if (observer) {
    observer.disconnect()
  }
  const domElement = document.querySelector('h1')
  if (lastElement && Number.parseInt(lastElement?.name) && domElement) {
    const lastEl = path[path.length - 1].name
    if (domElement.textContent) {
      if (realNames.value.filter(item => item.name == lastEl).length > 0) {
        realNames.value = realNames.value.filter(item => item.name != lastEl)
      }
      realNames.value.push({ name: lastEl, realName: domElement.textContent })
    }
    observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (realNames.value.filter(item => item.name == lastEl).length > 0) {
          realNames.value = realNames.value.filter(item => item.name != lastEl)
        }
        realNames.value.push({
          name: lastEl,
          realName: mutation.addedNodes[mutation.addedNodes.length - 1]?.data ?? mutation.addedNodes[0]?.data,
        })
      })
    })
    observer.observe(domElement, { childList: true, characterData: true, subtree: true })
  }

  //nothing + reset example /wastecollection/waste
  let shouldReset = false
  if (Array.isArray(path) && path.length > 0) {
    const minusOneException = minusOneExceptionsNames.includes(path[0].name)

    const firstPathException = firstPathExceptionsNames.includes(path[0].name)
    if (minusOneException) {
      if (path.length < 2) {
        shouldReset = true
      }
    } else if (firstPathException) {
      if (path.length < 3) {
        shouldReset = true
      }
    } else {
      if (path.length < 2) {
        shouldReset = true
      }
    }
  }

  if (shouldReset === true) {
    realNames.value = []
    visitedPaths.value = []
    return
  }
  //navigation back
  const previousPath = visitedPaths.value[visitedPaths.value.length - 2] || []
  const lastPath = visitedPaths.value[visitedPaths.value.length - 1] || []
  //Detect current not changed path refresh
  if (lastPath && JSON.stringify(lastPath[lastPath?.length - 1]) == JSON.stringify(path[path?.length - 1])) {
    return
  }
  //Detect previous path back button

  if (
    previousPath &&
    JSON.stringify(previousPath[previousPath?.length - 1]) == JSON.stringify(path[path?.length - 1])
  ) {
    visitedPaths.value.splice(-1)
    return
  }

  //if its visited paths and path
  if (visitedPaths.value.length > 0 && path.length > 2 && path !== visitedPaths.value[0]) {
    //if last path visited is same as curentPath without last subpath so its edit etc...
    const lastHistoryArray = visitedPaths.value[visitedPaths.value.length - 1]

    let lastIndex

    path.filter((item, index) => {
      if (
        item?.name == lastHistoryArray[lastHistoryArray.length - 1]?.name &&
        item?.path == lastHistoryArray[lastHistoryArray.length - 1]?.path
      ) {
        lastIndex = index
      }
    })

    path.splice(0, lastIndex + 1)
    visitedPaths.value.push(path)

    return
  } else {
    visitedPaths.value.push(path)
    return
  }
}
function pathNoIndex(path) {
  return path.slice(1)
}
function pathToArray(path) {
  return path.split('/')
}

function slicePath(howMuch) {
  if (!Array.isArray(visitedPaths.value) || visitedPaths.value.length === 0 || typeof howMuch !== 'number') {
    return
  }
  for (let index = visitedPaths.value.length - 1; index >= 0; index--) {
    const currentHowMuch = howMuch
    howMuch = howMuch - visitedPaths.value[index].length
    visitedPaths.value[index].splice(currentHowMuch * -1)
    if (howMuch <= 1) {
      break
    }
  }
  visitedPaths.value = [...visitedPaths.value.filter(path => path.length > 0)]
}

const checkPathValidity = path => {
  const resolvedRoute = router.resolve(path)
  return resolvedRoute.matched.length > 0
}
</script>
<template>
  <ul>
    <template v-if="visitedPaths && Array.isArray(visitedPaths) && visitedPaths.flat().length > 1">
      <template v-for="(path, pathIndex) in visitedPaths.flat()" :key="pathIndex">
        <li v-if="checkPathValidity(path.path)">
          <NuxtLink
            :to="path.path"
            @click="
              () =>
                visitedPaths.flat().length === pathIndex + 1 ? null : slicePath(visitedPaths.flat().length - pathIndex)
            "
          >
            {{ name(path) }}
          </NuxtLink>
        </li>
      </template>
    </template>
  </ul>
</template>
<style scoped>
ul {
  display: flex;
  list-style-type: none;
  padding: 4px;
  margin: 0;
  gap: 4px;
  padding-bottom: 12px;
  background-color: none;
  overflow-x: hidden;
  max-width: 80vw;
  text-wrap: nowrap;
  overflow-x: auto;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
ul::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
li a {
  text-decoration: none;
}
li:not(:last-child) a {
  color: var(--bs-secondary-color);
}
li:not(:last-child) a::after {
  content: '>';
  color: var(--bs-secondary-color);
  margin-left: 4px;
}
</style>
